import React, { useEffect, useRef, useState } from 'react';
import styles from './AdminMobileUserRegister.module.css';
import Container from 'layouts/container/Container';
import { mainBgColor, mainPadd, mainPadd2, pageCommonGap1, pageCommonPadd2, pageH1FontSize, registerFontSize, registerGap1, registerGap2, registerHeight } from '../constraints/AdminConst';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import useCustomAdminMobileMove from '../hooks/useCustomAdminMobileMove';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import AdminMobileContentBox from '../components/common/AdminMobileContentBox';
import { validateInputs } from 'shared/utils/Utils';
import { toast } from "react-toastify";
import InputText from 'components/inputs/signUp/InputText';
import { textFormat } from "InitialData/regExp";

// 유저 테스트 데이터
import testUserData from 'routes/adminMobile/commonVar/testUserData';
import { CFormSelect } from '@coreui/react';

const AdminMobileUserRegister = () => {
    const inputs = useRef([]);
    const [categories, setCategories] = useState();
    const [selectedCategory, setSelectedCategory] = useState();
    const [affiliations, setAffiliations] = useState();
    const [selectedAffiliation, setSelectedAffiliation] = useState();
    const {moveToBack} = useCustomAdminMobileMove();

    let data = {
        userId: "",
        userName: "",
        userStatus: selectedCategory === "" ? null : selectedCategory,
        userAffiliation: selectedAffiliation === "" ? null : selectedAffiliation,
        userPhone: "",
    };
    

    useEffect(() => {
        // testUserData 배열에서 중복을 제거한 userStatus 추출하여 categories 설정
        const extractUniqueUserStatus = () => {
            const userStatusSet = new Set(testUserData.map(user => user.userStatus));
            return Array.from(userStatusSet);
        };

        setCategories(extractUniqueUserStatus());
    }, []);
    

    const handleSelectChangeCategory = (event) => {
        // 여기에서 선택된 카테고리의 ID를 사용할 수 있습니다.
        
        setSelectedCategory(event.target.value);
    };

    useEffect(() => {
        // testUserData 배열에서 중복을 제거한 userStatus 추출하여 categories 설정
        const extractUniqueUserAffiliation = () => {
            const userAffiliationSet = new Set(testUserData.map(user => user.userAffiliation));
            return Array.from(userAffiliationSet);
        };

        setAffiliations(extractUniqueUserAffiliation());
    }, []);
    

    const handleSelectChangeAffiliation = (event) => {
        // 여기에서 선택된 소속점포의 ID를 사용할 수 있습니다.
        
        setSelectedAffiliation(event.target.value);
    };

    // 유저 등록 버튼 클릭 함수
    const onClick = () => {
        // 초기화 된 데이터
        

        validateInputs(inputs.current).then((result) => {
            if(result.isValid) {
                data.userId = inputs.current[0].getValue();
                data.userName = inputs.current[1].getValue();
                data.userPhone = inputs.current[2].getValue() + "-" 
                    + inputs.current[3].getValue() + "-" 
                    + inputs.current[4].getValue();

                // validate 이후 데이터 확인
                
            }else {
                toast.error(`${inputs.current[result.index].getName()} 항목을 확인해주세요`, {
                    autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                });
            }
        });
    };

    return (
        <Container height={registerHeight}>
            <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor} padding={pageCommonPadd2}>
                <FlexChild height={"initial"} padding={mainPadd}>
                    <HorizontalFlex>
                        <FlexChild width="auto">
                            <img onClick={() => moveToBack()} className={styles.backIcon} src={backIcon} alt='뒤로 가기 버튼' />
                        </FlexChild>
                        <FlexChild justifyContent="center">
                            {/* H1 헤더 */}
                            <P size={pageH1FontSize}>유저 등록</P>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex backgroundColor={mainBgColor} padding={mainPadd2} gap={registerGap1}>
                        <FlexChild>
                            <AdminMobileContentBox flexStart>
                                {/* 
                                    유저 아이디
                                    유저 이름
                                    유저 카테고리(셀렉트)
                                    유저 소속점포(셀렉트)
                                    유저 전화번호(입력창3개, 사이에 '-' 넣기)
                                */}
                                <VerticalFlex gap={registerGap1}>
                                    {/* 반복 구간 */}
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>아이디</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[0] = el)} placeHolder={"아이디 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>이름</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <InputText ref={el => (inputs.current[1] = el)} placeHolder={"이름 입력"} regExp={[textFormat]} />
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>카테고리</P>
                                            </FlexChild>
                                            <FlexChild>
                                                {/* 카테고리 생성 */}
                                                <CFormSelect value={selectedCategory} onChange={handleSelectChangeCategory}>
                                                    <option value="">선택하세요</option>
                                                    {categories && categories.map((category, index) => (
                                                        <option key={index} value={category}>
                                                            {category === "admin" && "본사"}
                                                            {category === "clerk" && "점원"}
                                                            {category === "vendor" && "점주"}
                                                        </option>
                                                    ))}
                                                </CFormSelect>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>소속점포</P>
                                            </FlexChild>
                                            <FlexChild>
                                                {/* 소속점포 생성 */}
                                                <CFormSelect value={selectedAffiliation} onChange={handleSelectChangeAffiliation}>
                                                    <option value="">선택하세요</option>
                                                    {affiliations && affiliations.map((affiliation, index) => (
                                                        <option key={index} value={affiliation}>
                                                            {affiliation}
                                                        </option>
                                                    ))}
                                                </CFormSelect>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild alignItems="flex-start">
                                        <VerticalFlex gap={registerGap2}>
                                            <FlexChild alignItems="flex-start">
                                                <P size={registerFontSize}>전화번호</P>
                                            </FlexChild>
                                            <FlexChild>
                                                <HorizontalFlex gap={registerGap2}>
                                                    <FlexChild>
                                                        <InputText ref={el => (inputs.current[2] = el)} placeHolder={"010"} regExp={[textFormat]} />
                                                    </FlexChild>
                                                    <FlexChild width="auto">
                                                        <P>-</P>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <InputText ref={el => (inputs.current[3] = el)} placeHolder={"1234"} regExp={[textFormat]} />
                                                    </FlexChild>
                                                    <FlexChild width="auto">
                                                        <P>-</P>
                                                    </FlexChild>
                                                    <FlexChild>
                                                        <InputText ref={el => (inputs.current[4] = el)} placeHolder={"1234"} regExp={[textFormat]} />
                                                    </FlexChild>
                                                </HorizontalFlex>
                                            </FlexChild>
                                        </VerticalFlex>
                                    </FlexChild>
                                    {/* 반복 구간 */}
                                </VerticalFlex>
                            </AdminMobileContentBox>
                        </FlexChild>
                        <FlexChild height="initial">
                            <div className={styles.regiBtn} onClick={onClick}>
                                <span>유저 등록</span>
                            </div>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </Container>
    );
};

export default AdminMobileUserRegister;